// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ utils
const { formatAmount } = require('utilities/currencyHelper');
const { VALUE_TYPES } = require('../../../insuranceConstants/insuranceRequestHome');

// @ utils
const { getLanguage } = require('core/i18n').i18n;

// @ constants
const { EURO_SYMBOL } = require('constants/index');

const InsuranceRequestPlansRowValue = props => {
    const {
        insuranceUsabilityImprovementsFlag,
        type,
        value,
        valueOld,
    } = props;

    const language = getLanguage();
    let rowValue = (
        <div className="coverage-and-plans__icon-container">
            <span className="icon-cerrar coverage-and-plans__icon-close" />
        </div>
    );

    const iconCheckedRowClasses = classnames('coverage-and-plans__icon-checked', {
        'coverage-and-plans__icon-checked--inline': insuranceUsabilityImprovementsFlag
    });

    if (type === VALUE_TYPES.CHECK) {
        if (value === '1') {
            rowValue = (
                <div className="coverage-and-plans__icon-container">
                    <span className="coverage-and-plans__icon-checked" />
                </div>
            );
        }
        else if (value === '2') {
            rowValue = (
                <td className="coverage-and-plans__icon-container">
                    <span className={iconCheckedRowClasses} />
                    <span className={iconCheckedRowClasses} />
                </td>
            );
        }
    } else if (type === VALUE_TYPES.DOGS) {
        rowValue = <span className="coverage-and-plans__total-value">{value}</span>;
    } else {
        if (!!valueOld && (valueOld !== value)) {
            const totalValueOld = `${formatAmount(valueOld, language, 0)} ${EURO_SYMBOL}`;
            const totalValue = `${formatAmount(value, language, 0)} ${EURO_SYMBOL}`;
            rowValue = (<div className="coverage-and-plans__value-container">
                <span className="coverage-and-plans__total-value-old">{totalValueOld}</span>
                <span className="coverage-and-plans__total-value">{totalValue}</span>
            </div>);
        } else {
            const totalValue = `${formatAmount(value, language, 0)} ${EURO_SYMBOL}`;
            rowValue = <span className="coverage-and-plans__total-value">{totalValue}</span>;
        }
    }

    return rowValue;
};

InsuranceRequestPlansRowValue.propTypes = {
    insuranceUsabilityImprovementsFlag: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    valueOld: PropTypes.string,
};

module.exports = InsuranceRequestPlansRowValue;
